import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';

const PopUpService = {
  getTxtPopUp: (data: any) => {
    return trackPromise(
      api.post(`/rest/${i18next.language}/txt/banner`, JSON.stringify(data)),
    );
  },
};
export default PopUpService;
